import { useCart } from '@/contexts/CartContext';
import { useProducts } from '@/contexts/ProductsContext';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackAddToCart } from '@/lib/tracking';

export default function StickyBuyBar() {
  const { t } = useTranslation();
  const { cart, addToCart, openCart } = useCart();
  const { routineSet } = useProducts();
  const location = useLocation();

  // /lp/* ad landing pages have their own single CTA block, and
  // /3-step-treatment has its own Buy Now bar (ThreeStepStickyBar) — no
  // separate sticky bar competing with (and covering) it.
  const hidePaths = ['/checkout', '/order', '/admin', '/lp/', '/3-step-treatment'];
  const shouldHide = hidePaths.some((p) => location.pathname.includes(p));

  if (shouldHide) return null;

  // The bar advertises the 3-Step Set, so with an empty cart the button adds
  // it first; opening an empty cart left ad visitors with nothing to buy.
  const shopNow = () => {
    if (cart.length === 0) {
      addToCart('3-step-set', 1);
      if (routineSet) {
        trackAddToCart({ id: '3-step-set', name: routineSet.name, price: Number(routineSet.price.replace(/[^0-9.]/g, '')), quantity: 1 });
      }
    }
    openCart();
  };

  return (
    <div className="fixed bottom-0 left-0 w-full z-[45] bg-white border-t border-[#E8E8E6] px-5 py-3 flex items-center justify-between md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <div className="flex flex-col gap-0.5 min-w-0 flex-1 mr-3">
        <span className="text-xs font-medium text-[#2A2A2A] truncate">
          {t('stickyBar.product', '3-Step Daily Treatment Set')}
        </span>
        <span className="text-[11px] text-[#7B1113] font-medium truncate">
          ৳8,000 {t('stickyBar.save', '(Save ৳500)')}
        </span>
      </div>
      <button
        onClick={shopNow}
        className="px-5 py-2.5 bg-[#7B1113] text-white text-[11px] tracking-[0.12em] uppercase rounded-full hover:bg-[#5C0D0F] transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
      >
        {t('common.shopNow')} →
      </button>
    </div>
  );
}